import { useEffect } from 'react';

export type Bound = Record<number, [[number, number], [number, number]]>;

export type Options = {
  minZoom: number;
  maxZoom: number;
};

const DEFAULT_OPTIONS: Options = {
  maxZoom: 20,
  minZoom: 16,
};

export type MapImageOptions = {
  bounds?: Bound;
  map: google.maps.Map | null;
  imageUrl?: string;
  options?: Options;
};

export const useMapsImage = ({
  bounds,
  map,
  imageUrl,
  options = DEFAULT_OPTIONS,
}: MapImageOptions) => {
  const addImage = () => {
    if (!bounds || !imageUrl || !map) {
      return;
    }

    const { maxZoom, minZoom } = options;

    const imageMapType = new google.maps.ImageMapType({
      getTileUrl: function (coord: { x: number; y: number }, zoom: number) {
        /**
         * There must be the parameters minZoom and maxZoom
         */
        if (!minZoom || !maxZoom) {
          return '';
        }

        /**
         * The current zoom must be between minZoom and maxZoom
         */
        if (zoom < minZoom || zoom > maxZoom) {
          return '';
        }

        if (
          bounds[zoom][0][0] > coord.x ||
          coord.x > bounds[zoom][0][1] ||
          bounds[zoom][1][0] > coord.y ||
          coord.y > bounds[zoom][1][1]
        ) {
          return '';
        }

        const tileUrl = [
          imageUrl,
          zoom,
          '_',
          coord.x,
          '_',
          coord.y,
          '.png',
        ].join('');

        return tileUrl;
      },
      tileSize: new google.maps.Size(256, 256),
    });

    map.overlayMapTypes.push(imageMapType);
  };

  useEffect(() => {
    if (bounds && imageUrl && map) {
      addImage();
    }
  }, [bounds, imageUrl, map, addImage]);

  return;
};
